import { position } from "dom-helpers";
import React, { useState, useEffect } from "react";
import tag from "../Assets/img/tag.png";
import Rectangle from "../Assets/img/Rectangle.png";
import { Link } from "react-router-dom";
import style from "../Assets/css/jobpostingpage.module.css";
import JobPostingLeftComp from "./JobPostingLeftComp";
import JobPostComp from "./JobPostComp";
import useMedia from "../componentsofcourse/useMedia";
import AOS from "aos";
import "aos/dist/aos.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
export default function JobPostingPage() {
	useEffect(() => {
		AOS.init();
	});
	const API_ENDPOINT = "https://api.cantileverlabs.com/";
	//const API_ENDPOINT = "http://localhost:5000/";
	const [newJobs, setNewjobs] = useState([
		{ dateAdded: "10", dueDate: "10", loadingState: true },
	]);
	const [search, newSearch] = useState("");
	const [data, setData] = useState(newJobs);
	const [roles, setRoles] = useState([]);
	const [sortby, setsortby] = useState("none");
	const [selected, setSelected] = useState("ALL");
	const [Onelocation, setOnelocation] = useState("ALL Location");
	const [jobPostings, setJobPostings] = useState([
		{ dateAdded: "10", dueDate: "10", loadingState: true },
	]);

	const [filter, setFilter] = useState(false);
	const matches = useMedia("(min-width : 768px )");
	const [fullTime, setFulltime] = useState("ALL");
	const [locations, setLocation] = useState([]);
	const [change, setchange] = useState(false);
	function handleFilter() {
		setFilter(!filter);
	}

	useEffect(() => {
		fetch(`${API_ENDPOINT}getJobPostingsAll`)
			.then((res) => res.json())
			.then((data) => {
				return setJobPostings(data);
			})
			.catch((err) => console.log(err));
	}, [API_ENDPOINT]);

	useEffect(() => {
		if (
			selected == "ALL" &&
			Onelocation == "ALL Location" &&
			fullTime == "ALL"
		) {
			setData(jobPostings);
		} else {
			if (
				Onelocation == "ALL Location" &&
				fullTime == "ALL" &&
				selected !== "ALL"
			) {
				const filteredData = jobPostings.filter((value, index) => {
					if (value.positionName.includes(selected)) {
						return value;
					}
				});
				setData(filteredData);
			} else if (
				Onelocation !== "ALL Location" &&
				fullTime == "ALL" &&
				selected == "ALL"
			) {
				const filteredData = ValueforLocation();
				setData(filteredData);
			} else if (
				Onelocation === "ALL Location" &&
				fullTime !== "ALL" &&
				selected == "ALL"
			) {
				const filteredData = valueforFullTime();
				setData(filteredData);
			} else if (
				Onelocation !== "ALL Location" &&
				fullTime !== "ALL" &&
				selected == "ALL"
			) {
				const newFilteredData = valueforFullTime(fullTime);
				const filteredData = ValueforLocation(newFilteredData);

				setData(filteredData);
			} else if (
				Onelocation !== "ALL Location" &&
				fullTime == "ALL" &&
				selected !== "ALL"
			) {
				const filteredData = ValueforLocation();
				const newFilteredData = ValueforSelected(filteredData);
				setData(newFilteredData);
			} else if (
				Onelocation == "ALL Location" &&
				fullTime !== "ALL" &&
				selected !== "ALL"
			) {
				const filteredData = valueforFullTime(fullTime);
				const newFilteredData = ValueforSelected(filteredData);

				setData(newFilteredData);
			} else if (
				Onelocation !== "ALL Location" &&
				fullTime !== "ALL" &&
				selected !== "ALL"
			) {
				const filteredData = valueforFullTime(fullTime);
				const midData = ValueforLocation(filteredData);
				const newfilteredData = ValueforSelected(midData);
				setData(newfilteredData);
			}
		}
	}, [selected]);
	//this is all about the changes in the Location
	useEffect(() => {
		if (
			Onelocation === "ALL Location" &&
			selected == "ALL" &&
			fullTime == "ALL"
		) {
			return setData(jobPostings);
		}
		// Location isn't all apart from that selected is all and fulltime is also all
		else if (
			Onelocation !== "ALL Location" &&
			selected == "ALL" &&
			fullTime == "ALL"
		) {
			var filteredData = ValueforLocation();
			setData(filteredData);
		} //selected can be something and fulltime is all
		else if (selected !== "ALL" && fullTime === "ALL") {
			var FilteredData = ValueforSelected();
			const newFilteredData = FilteredData.filter((value, index) => {
				if (value.Location === Onelocation) {
					return value;
				}
			});
			// console.log(newFilteredData)
			setData(newFilteredData);
		} //selected is all and full time can be something
		else if (
			selected === "ALL" &&
			fullTime !== "ALL" &&
			Onelocation !== "ALL Location"
		) {
			var filteredData = valueforFullTime(fullTime);
			console.log(filteredData);
			var newFilteredData = ValueforLocation(filteredData);
			setData(newFilteredData);
		} else if (
			selected == "ALL" &&
			fullTime !== "ALL" &&
			Onelocation == "ALL Location"
		) {
			var filteredData = valueforFullTime(fullTime);
			setData(filteredData);
		} else if (
			selected == "ALL" &&
			fullTime == "ALL" &&
			Onelocation !== "ALL Location"
		) {
			var filteredData = ValueforLocation(Onelocation);
			setData(filteredData);
		} else if (
			fullTime == "ALL" &&
			Onelocation == "ALL Location" &&
			selected !== "ALL"
		) {
			var filteredData = ValueforSelected();
			setData(filteredData);
		} else {
			const FilteredData = jobPostings.filter((value, index) => {
				if (value.Location === Onelocation) {
					return value;
				}
			});
			// console.log(FilteredData)
			setData(FilteredData);
		}
	}, [Onelocation]);

	function onlyUnique(value, index, self) {
		return self.indexOf(value) === index;
	}
	useEffect(() => {
		// console.log(jobPostings)
		setData(jobPostings);
		const ROLES = jobPostings.map((value, index) => value.positionName);
		var uniqueROLES = ROLES.filter(onlyUnique);
		setRoles(uniqueROLES);
		// console.log(ROLES);
		const LOCATION = jobPostings.map((value, index) => value.Location);
		var uniqueLocation = LOCATION.filter(onlyUnique);
		setLocation(uniqueLocation);
	}, [jobPostings]);
	function HandleChange(value) {
		newSearch(value);
	}

	function enterhandle(e) {
		e.preventDefault();
		if (e.keyCode === 13) {
			filterData();
		}
	}

	function searchList(value) {
		var lowerCaseValue = search.toLowerCase().trim();
		var filtereddata = [];
		if (value !== undefined) {
			filtereddata = value.filter((item) => {
				return Object.keys(item).some((key) => {
					return item[key]
						.toString()
						.toLowerCase()
						.includes(lowerCaseValue);
				});
			});
		} else {
			// alert("hellop")

			filtereddata = jobPostings.filter((item) => {
				return Object.keys(item).some((key) => {
					return item[key]
						.toString()
						.toLowerCase()
						.includes(lowerCaseValue);
				});
			});
			setData(filtereddata);
			console.log(filtereddata);
		}
		return filtereddata;
	}

	//search functionality
	function filterData(e) {
		e.preventDefault();
		var lowerCaseValue = search.toLowerCase().trim();
		// var FilteredData=[]
		if (
			fullTime == "ALL" &&
			Onelocation == "ALL Location" &&
			selected == "ALL"
		) {
			searchList();
		} else if (
			fullTime !== "ALL" &&
			Onelocation == "ALL Location" &&
			selected == "ALL"
		) {
			const filteredData = valueforFullTime(fullTime);
			const newfilteredData = searchList(filteredData);
			setData(newfilteredData);
		} else if (
			fullTime === "ALL" &&
			Onelocation !== "ALL Location" &&
			selected == "ALL"
		) {
			const filteredData = ValueforLocation();
			const newfilteredData = searchList(filteredData);
			setData(newfilteredData);
		} else if (
			fullTime == "ALL" &&
			Onelocation == "ALL Location" &&
			selected !== "ALL"
		) {
			const filteredData = ValueforSelected();
			const newfilteredData = searchList(filteredData);
			setData(newfilteredData);
		} else if (
			fullTime !== "ALL" &&
			Onelocation !== "ALL Location" &&
			selected == "ALL"
		) {
			const filteredData = valueforFullTime(fullTime);
			const intermediateData = ValueforLocation(filteredData);
			const newfilteredData = searchList(intermediateData);
			setData(newfilteredData);
		} else if (
			fullTime !== "ALL" &&
			Onelocation == "ALL Location" &&
			selected !== "ALL"
		) {
			const filteredData = valueforFullTime(fullTime);
			const intermediateData = ValueforSelected(filteredData);
			const newfilteredData = searchList(intermediateData);
			setData(newfilteredData);
		} else if (
			fullTime == "ALL" &&
			Onelocation !== "ALL Location" &&
			selected !== "ALL"
		) {
			const filteredData = ValueforLocation();
			const intermediateData = ValueforSelected(filteredData);
			const newfilteredData = searchList(intermediateData);
			setData(newfilteredData);
		} else if (
			fullTime == "ALL" &&
			Onelocation == "ALL Location" &&
			selected == "ALL"
		) {
			const filteredData = valueforFullTime(fullTime);
			const intermediateData = ValueforSelected(filteredData);
			const intermediateData_2 = ValueforLocation(intermediateData);
			const newfilteredData = searchList(intermediateData_2);
			setData(newfilteredData);
		}
		// if (!lowerCaseValue) {
		//     setData(jobPostings);
		// } else {

		//     if (fullTime == "ALL") {
		//         const filteredData = jobPostings.filter(item => {
		//             return Object.keys(item).some(key => {
		//                 return item[key].toString().toLowerCase().includes(lowerCaseValue);
		//             })
		//         })
		//         setData(filteredData)
		//     } else if (fullTime == "FULL") {
		//         FilteredData = jobPostings.filter((value,index)=>{
		//         if(value.Fulltime == true){
		//             return value
		//         }
		//         })
		//         setData(FilteredData)

		//         const filteredData = FilteredData.filter(item => {
		//             return Object.keys(item).some(key => {
		//                 return item[key].toString().toLowerCase().includes(lowerCaseValue);
		//             })
		//         })
		//         setData(filteredData)

		//     } else if (fullTime == "INTERN") {
		//         FilteredData = jobPostings.filter((value,index)=>{
		//         if(value.Fulltime == false){
		//             return value
		//         }
		//         })
		//         setData(FilteredData)
		//         console.log(FilteredData)
		//         const filteredData = FilteredData.filter(item => {
		//             return Object.keys(item).some(key => {
		//                 return item[key].toString().toLowerCase().includes(lowerCaseValue);
		//             })
		//         })
		//         setData(filteredData)
		//     }

		// }
	}

	function dateSetFunc(msecString) {
		let time_string = new Date(parseInt(msecString));
		return `${time_string.getDate()}-${
			time_string.getMonth() + 1
		}-${time_string.getFullYear()}`;
	}

	//radio button filter function
	function FiltersForFullTime(values) {
		var FILTEREDDATA = [];
		//both the parameters are default
		if (Onelocation === "ALL Location" && selected == "ALL") {
			FILTEREDDATA = jobPostings.filter((value, index) => {
				if (value.Fulltime == values) {
					return value;
				}
			});
		}
		//role is ALL but location isn't
		else if (Onelocation !== "ALL Location" && selected == "ALL") {
			const filteredData = ValueforLocation();

			FILTEREDDATA = filteredData.filter((value, index) => {
				if (value.Fulltime == values) {
					return value;
				}
			});
		}
		//location is ALL but role isn't
		else if (Onelocation == "ALL Location" && selected !== "ALL") {
			const filteredData = ValueforSelected();

			FILTEREDDATA = filteredData.filter((value, index) => {
				if (value.Fulltime == values) {
					return value;
				}
			});
			console.log(FILTEREDDATA);
		} else {
			//jab dono bi random values hain
			const FilteredData = ValueforLocation();
			const newFilteredData = ValueforSelected(FilteredData);
			FILTEREDDATA = newFilteredData.filter((value, index) => {
				if (value.Fulltime == values) {
					return value;
				}
			});
		}
		return FILTEREDDATA;
	}

	//intern ship radio button filter with other filters as ON
	useEffect(() => {
		var FILTEREDDATA = [];
		if (
			fullTime === "ALL" &&
			selected == "ALL" &&
			Onelocation == "ALL Location"
		) {
			FILTEREDDATA = jobPostings;
		} else if (
			fullTime !== "ALL" &&
			selected == "ALL" &&
			Onelocation == "ALL Location"
		) {
			const filteredData = valueforFullTime(fullTime);
			FILTEREDDATA = filteredData;
		} else if (
			fullTime == "ALL" &&
			selected !== "ALL" &&
			Onelocation == "ALL Location"
		) {
			const filteredData = ValueforSelected();
			FILTEREDDATA = filteredData;
		} else if (
			fullTime == "ALL" &&
			selected == "ALL" &&
			Onelocation !== "ALL Location"
		) {
			const filteredData = ValueforLocation();
			FILTEREDDATA = filteredData;
		} else if (
			fullTime !== "ALL" &&
			selected !== "ALL" &&
			Onelocation == "ALL Location"
		) {
			const filteredData = valueforFullTime(fullTime);
			const newFilteredData = ValueforSelected(filteredData);
			FILTEREDDATA = newFilteredData;
		} else if (
			fullTime !== "ALL" &&
			selected === "ALL" &&
			Onelocation == "ALL Location"
		) {
			const filteredData = valueforFullTime(fullTime);
			const newFilteredData = ValueforLocation(filteredData);
			FILTEREDDATA = newFilteredData;
		} else if (
			fullTime == "ALL" &&
			selected !== "ALL" &&
			Onelocation !== "ALL Location"
		) {
			const filteredData = ValueforSelected();
			const newFilteredData = ValueforLocation(filteredData);
			FILTEREDDATA = newFilteredData;
		} else {
		}

		return setData(FILTEREDDATA);
	}, [fullTime]);

	function ValueforChange(value) {
		var filteredData = [];
		if (value == undefined) {
			filteredData = jobPostings.filter((value, index) => {
				if (value.Remote === true) {
					return value;
				}
			});
		} else {
			filteredData = value.filter((value, index) => {
				if (value.Remote === true) {
					return value;
				}
			});
		}
		console.log(filteredData);
		return filteredData;
	}

	useEffect(() => {
		if (
			fullTime === "ALL" &&
			selected == "ALL" &&
			Onelocation == "ALL Location" &&
			change == false
		) {
			setData(jobPostings);
		}
		if (
			fullTime == "ALL" &&
			selected == "ALL" &&
			Onelocation == "ALL Location" &&
			change !== false
		) {
			const filteredData = ValueforChange();
			setData(filteredData);
		}
		if (
			fullTime == "ALL" &&
			selected == "ALL" &&
			Onelocation !== "ALL Location" &&
			change == false
		) {
			const filteredData = ValueforLocation();
			setData(filteredData);
		}
		if (
			fullTime == "ALL" &&
			selected !== "ALL" &&
			Onelocation == "ALL Location" &&
			change == false
		) {
			const filteredData = ValueforSelected();
			setData(filteredData);
		}
		if (
			fullTime !== "ALL" &&
			selected == "ALL" &&
			Onelocation == "ALL Location" &&
			change == false
		) {
			const filteredData = valueforFullTime(fullTime);
			setData(filteredData);
		}
		if (
			fullTime !== "ALL" &&
			selected !== "ALL" &&
			Onelocation == "ALL Location" &&
			change == false
		) {
			const filteredData = valueforFullTime(fullTime);
			const newFilteredData = ValueforSelected(filteredData);
			setData(newFilteredData);
		}
		if (
			fullTime !== "ALL" &&
			selected == "ALL" &&
			Onelocation !== "ALL Location" &&
			change == false
		) {
			const filteredData = valueforFullTime(fullTime);
			const newfilteredData = ValueforLocation(filteredData);
			setData(newfilteredData);
		}
		if (
			fullTime !== "ALL" &&
			selected == "ALL" &&
			Onelocation == "ALL Location" &&
			change !== false
		) {
			const fileredData = valueforFullTime(fullTime);
			const newfilterdData = ValueforChange(fileredData);
			setData(newfilterdData);
		}
		if (
			fullTime == "ALL" &&
			selected !== "ALL" &&
			Onelocation !== "ALL Location" &&
			change == false
		) {
			const filteredData = ValueforSelected();
			const newfilteredData = ValueforLocation(filteredData);
			setData(newfilteredData);
		}
		if (
			fullTime == "ALL" &&
			selected !== "ALL" &&
			Onelocation == "ALL Location" &&
			change !== false
		) {
			const filtredData = ValueforSelected();
			const newfilterdData = ValueforChange(filtredData);
			setData(newfilterdData);
		}
		if (
			fullTime == "ALL" &&
			selected == "ALL" &&
			Onelocation !== "ALL Location" &&
			change !== false
		) {
			const filterdData = ValueforLocation();
			const newfilteredData = ValueforChange(filterdData);
			setData(newfilteredData);
		}
		if (
			fullTime !== "ALL" &&
			selected !== "ALL" &&
			Onelocation !== "ALL Location" &&
			change == false
		) {
			const filterdData = valueforFullTime(fullTime);
			const newfiltredData = ValueforSelected(filterdData);
			const filter = ValueforLocation(newfiltredData);
			setData(filter);
		}
		if (
			fullTime !== "ALL" &&
			selected !== "ALL" &&
			Onelocation == "ALL Location" &&
			change !== false
		) {
			const filterdData = valueforFullTime(fullTime);
			const newfiltredData = ValueforSelected(filterdData);
			const filter = ValueforChange(newfiltredData);
			setData(filter);
		}
		if (
			fullTime == "ALL" &&
			selected !== "ALL" &&
			Onelocation !== "ALL Location" &&
			change !== false
		) {
			const filterdData = ValueforLocation();
			const newfiltredData = ValueforSelected(filterdData);
			const filter = ValueforLocation(newfiltredData);
			setData(filter);
		}
		if (
			fullTime !== "ALL" &&
			selected == "ALL" &&
			Onelocation !== "ALL Location" &&
			change !== false
		) {
			const filterdData = valueforFullTime(fullTime);
			const newfiltredData = ValueforLocation(filterdData);
			const filter = ValueforChange(newfiltredData);
			setData(filter);
		}
		if (
			fullTime !== "ALL" &&
			selected !== "ALL" &&
			Onelocation !== "ALL Location" &&
			change !== false
		) {
			const filteredData = valueforFullTime(fullTime);
			const newFilteredData = ValueforSelected(filteredData);
			const middata = ValueforLocation(newFilteredData);
			const changeData = ValueforLocation(middata);
			setData(changeData);
		}
	}, [change, selected, fullTime, Onelocation]);

	function valueforFullTimeFalse() {
		const FILTEREDDATA = jobPostings.filter((value, index) => {
			if (value.Fulltime == false) {
				return value;
			}
		});

		console.log(FILTEREDDATA);
		return FILTEREDDATA;
	}
	function valueforFullTimeTrue() {
		const FILTEREDDATA = jobPostings.filter((value, index) => {
			if (value.Fulltime == true) {
				return value;
			}
		});

		return FILTEREDDATA;
	}
	function valueforFullTime(value) {
		var FILTEREDDATA = [];
		if (value == "FULL") {
			FILTEREDDATA = valueforFullTimeTrue();
		} else if (value == "INTERN") {
			FILTEREDDATA = valueforFullTimeFalse();
		}

		return FILTEREDDATA;
	}
	//value for the location
	function ValueforLocation(filteredData) {
		if (filteredData === undefined) {
			const FilteredData = jobPostings.filter((value, index) => {
				if (value.Location === Onelocation) {
					return value;
				}
			});
			console.log(FilteredData);
			return FilteredData;
		} else {
			const FilteredData = filteredData.filter((value, index) => {
				if (value.Location === Onelocation) {
					return value;
				}
			});
			console.log(FilteredData);
			return FilteredData;
		}
	}

	//value for selected
	function ValueforSelected(array) {
		if (array !== undefined) {
			const filteredData = array.filter((value, index) => {
				if (value.positionName.includes(selected)) {
					return value;
				}
			});
			console.log(filteredData);
			return filteredData;
		} else {
			const filteredData = jobPostings.filter((value, index) => {
				if (value.positionName.includes(selected)) {
					return value;
				}
			});
			console.log(filteredData);
			return filteredData;
		}
	}

	//sorting result
	async function sortResults() {
		setFulltime("ALL");
		setSelected("ALL");
		setchange(false);
		setOnelocation("ALL Location");
		await setJobPostings([
			{ dateAdded: "10", dueDate: "10", loadingState: true },
		]);

		if (sortby === "latest" || sortby === "dueDate") {
			await fetch(`${API_ENDPOINT}jobPostingSortOrder?sortBy=${sortby}`)
				.then((res) => res.json())
				.then((data) => setJobPostings(data))
				.catch((err) => console.log(err));
			return;
		}
		fetch(`${API_ENDPOINT}getJobPostingsAll`)
			.then((res) => res.json())
			.then((data) => {
				return setJobPostings(data);
			})
			.catch((err) => console.log(err));
	}

	return (
		<>
			<Navbar />
			{matches === true ? (
				<>
					<div
						className={"container-fluid " + style.fontnew}
						style={{ padding: "0" }}
					>
						<h1
							className="px-4 py-5"
							style={{
								backgroundColor: "#185ADB",
								color: "white",
								fontWeight: "500",
							}}
						>
							Cantilever labs Placement Cell
						</h1>
					</div>

					<div className="container-fluid ">
						<div className="row">
							<div className="col-sm-4 py-4  ">
								<JobPostingLeftComp
									change={change}
									setchange={setchange}
									sortby={sortby}
									setsortby={setsortby}
									setFulltime={setFulltime}
									fullTime={fullTime}
									sortResults={sortResults}
									Onelocation={Onelocation}
									setOnelocation={setOnelocation}
									locationArr={locations}
									roles={roles}
									selected={selected}
									setSelected={setSelected}
								/>
							</div>
							<div className="col-sm-8">
								<div
									className="container p-0 m-0 "
									style={{ marginLeft: "0px" }}
								>
									<div
										className={
											"container mt-3  mx-4 " + style.wide
										}
										style={{
											height: "60px",
											marginLeft: "0px",
											paddingLeft: "0px",
										}}
									>
										<div
											className={
												"container m-1 rounded shadow-sm py-2 " +
												style.borders
											}
										>
											<form className="form-inline input-group rounded">
												<i
													class="fa fa-search"
													style={{
														fontSize: "20px",
														marginTop: "12px",
														paddingBottom: "6px",
													}}
												></i>
												<input
													onKeyPress={(e) => {
														if (e.keyCode == 13) {
															return enterhandle();
														}
													}}
													value={search}
													onChange={(e) =>
														HandleChange(
															e.target.value
														)
													}
													type="text"
													placeholder="Search anything"
													className={" px-2 "}
													style={{
														borderRadius: "6px",
														border: "None",
														marginTop: "0px",
														paddingTop: "3px",
													}}
												/>
												<button
													style={{ display: "none" }}
													onClick={filterData}
													type="submit"
												>
													Submit
												</button>
											</form>
										</div>

										{/* <div className="col-sm-6 mt-2 px-4" style={{borderRight:"1px solid black",height:"48px"}} >
                    <div class="form-check form-check-inline mt-3 mx-2" onChange={()=> setFulltime("FULL")} >
  <input  class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1"  value="FULL" checked={fullTime=="FULL" } />
  <label class={"form-check-label " } style={{fontSize:"0.7rem"}} for="inlineRadio1">Full Time Job</label>
</div>
<div class="form-check form-check-inline" onChange={()=>setFulltime("INTERN")} >
                                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="INTERN" checked={fullTime=="INTERN" }/>
  <label class="form-check-label" for="inlineRadio2" style={{fontSize:"0.7rem"}}>Internship</label>
                                </div>
                                <div class="form-check form-check-inline" onChange={()=>setFulltime("ALL")} >
  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="ALL" checked={fullTime==="ALL" } />
  <label class="form-check-label" for="inlineRadio2" style={{fontSize:"0.7rem"}}>ALL</label>
</div>

                    </div> */}

										{/* <div className="col-sm-3 mt-2 p-0">

                    <div class="form-check form-check-inline my-3" style={{paddingLeft:"3%"}}>
                    <label class="form-check-label" for="inlineRadio2" style={{fontSize:"0.7rem",marginRight:"2px"}}>Sort By: </label>
                    <select name="sortBy" id="sortBy" onChange={sortResults}>
                        <option value="none">None</option>
                        <option value="latest">Latest</option>
                        <option value="dueDate">Due Date</option>
                    </select>
                
                    </div>
                    </div> */}
									</div>
								</div>
								{/* {jobPostings.map((posting) => {
                return (
                    <>
                        
                        {posting.loadingState ? <><br/>Loading...</> : <Link to={`/jobposting/${posting._id}`}>
                            <br/>
                            <div>
                                <span>Position Name :</span> {posting.positionName}
                            </div>
                            <div>n
                                <span>Pay Range :</span> {posting.payRange}
                            </div>
                            <div>
                                <span>Skills Required :</span> {posting.skillsRequired}
                            </div>
                            <div>
                                <span>Date added :</span> {dateSetFunc(posting.dateAdded)}
                            </div>
                            <div>
                                <span>Last date to apply:</span> {dateSetFunc(posting.dueDate)}
                            </div>
                            <div>
                                <span>location:</span> {posting.Location}
                            </div>
                            <div>
                                <span>Vacancies:</span> {posting.vacancies}
                            </div>
                            <br/>
                        </Link>}
                    </>
                );
            })} */}
								{/* // the image of the rectangle is 25px so please keep in mind about that */}
								<div
									className={"row p-0 " + style.scrollremove}
									style={{
										overflowY: "scroll",
										maxHeight: "900px",
									}}
								>
									{data.length > 0 ? (
										<div>
											{data.map((value, index) => {
												return (
													<JobPostComp
														imgcompany={
															value.companyLogo
														}
														dueDate={value.dueDate}
														companyName={
															value.companyName
														}
														description={
															value.description
														}
														payrange={
															value.payRange
														}
														PositionName={
															value.positionName
														}
														id={value._id}
														location={
															value.Location
														}
													/>
												);
											})}{" "}
										</div>
									) : (
										<>
											{" "}
											<div className="container d-flex justify-content-center my-3">
												<h3 className="display-5">
													The job doesn't exist
												</h3>
											</div>{" "}
										</>
									)}

									{/* <div className={style.borders + " container p-5"}>
                    <div className="row d-flex justify-content-around" style={{ height: "6rem"}}>
                        <div className="col-sm-1" style={{width:"25px"}}>
                        <img src={Rectangle} alt="" />
                        
                        </div>
                        <div className="col-sm-6">
                            <div className="row">
                            <div className="col-sm-5" style={{marginBottom:"0%",width:"fit-content"}}>
                            <h4 class={style.job_list_hd1_J} style={{marginBottom:"0px",marginTop:"6%"}}>UI/UX Designer</h4>
                            </div>
                            <div className="col-sm-4" style={{marginTop:"0%",paddingLeft:"0px",height:"15px"}}>
                                    <a style={{marginBottom:"0px",marginTop:"6%",paddingBottom:"0px",float:"left"}} class={style.job_list_a_J + " mx-2" }  href=""> New</a>  
                                    </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-2 " >
                                    <p>Google</p>

                                </div>
                                <div className="col-sm-2">
                                    <p> Remote</p>
                                </div>
                            </div>
                            
                        </div>
                        <div className="col-4">
                        <img className="my-2" src={tag} alt="" style={{float:"right",marginRight:"30%"}} />
                    
                        </div>

                        
                    </div>
                    <div className="container">
                        <div className="row">
                           <div className="col-lg-4" style={{marginBottom:"0px"}}><p className="text-muted">Our remote company is seeking a passionate personal
                            to become the lead developer on our website</p></div>
                            
                        </div>
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col"><div className="row text-muted">
                                Apply BY
                            </div>
                            <div className="row ">
                                5Th Aug 21
                            </div></div>
                            <div className="col">

                                <div className="row text-muted">
                                    Duration
                                </div>
                                <div className="row">
                                    3 Months
                                </div>
                            
                            </div>
                            <div className="col">
                                <div className="row text-muted">
                                    Payment
                                </div>
                                <div className="row">
                                    4 LPA
                                </div>
                            </div>
                            <div className="col">
                            <div >
                                <button class={ style.somebtn + " px-3 mr-3 btn btn-outline-primary"}>Know More</button>
                            </div>
                            </div>
                        </div>
                        
                    </div>
                </div> */}
								</div>
							</div>
						</div>
					</div>
					{/* <div>
            Sort By:
            <select name="sortBy" id="sortBy" onChange={sortResults}>
                <option value="none">None</option>
                <option value="latest">Latest</option>
                <option value="dueDate">Due Date</option>
            </select>
            </div> */}
					<Footer />
				</>
			) : (
				<>
					<div style={{ borderBottom: "5px solid #E5E5E5" }}>
						<div
							style={{
								backgroundColor: "#185ADB",
								color: "white",
							}}
							className="container-fluid"
						>
							<p
								className="py-5 px-0"
								style={{ fontSize: "1.2rem" }}
							>
								{" "}
								Cantilever labs placement cell
							</p>
						</div>

						<div
							style={{ backgroundColor: "white" }}
							className="container-fluid py-5  d-flex justify-content-start"
						>
							<button
								style={{ fontSize: "0.8rem" }}
								onClick={handleFilter}
								className={
									"btn btn-outline-primary " + style.btnhover
								}
							>
								{filter == false ? "Filters" : "Close"}
							</button>

							{selected !== "ALL" && (
								<button
									style={{ fontSize: "0.8rem" }}
									onClick={() => {
										setSelected("ALL");
									}}
									className="btn  mx-3 btn-dark"
								>
									{selected + "  X"}
								</button>
							)}
						</div>
						{filter == true && (
							<JobPostingLeftComp
								locationArr={locations}
								roles={roles}
								selected={selected}
								setSelected={setSelected}
								platform="mobile"
							/>
						)}
					</div>
					{data.length > 0 ? (
						<div data-aos="fade-right">
							{data.map((value, index) => {
								return (
									<JobPostComp
										type="mobile"
										companyName={value.companyName}
										description={value.description}
										payrange={value.payRange}
										PositionName={value.positionName}
										id={value._id}
										dueDate={value.dueDate}
										location={value.Location}
									/>
								);
							})}{" "}
						</div>
					) : (
						<>
							{" "}
							<div className="container d-flex justify-content-center my-3">
								<h3 className="display-5">
									The job doesn't exist
								</h3>
							</div>{" "}
						</>
					)}
				</>
			)}
			<br />
		</>
	);
}
